<template>
    <div class="single-job-inline-container">
        <div class="job">
            <div class="job-brand">
                <div class="job-logo" v-if="job.logoData">
                    <img :src="job.logoData" class="logoSm">
                </div>
                
                <div to="/" class="close" @click="closeOverlay"></div>
            </div>

            <div class="job-description">
                <div class="job-description-other">
                    <Btn :to="job.apply" blank>Apply for this Job!</Btn>
                </div>
                <h1>{{job.title}}</h1>
                <h4>{{job.company}}</h4>
                <h2>{{job.city}},{{job.state}}</h2>

                <div class="job-description-meta">
                    <div class="pill" v-for="(t, index) in job.type" :key="index">
                        {{t}}
                    </div>
                    <div class="pill remote" v-if="job.remote">Remote Available</div>
                </div>

                <div v-if="job.embed" class="job-video">
                    <div class="responsive-container">
                        <iframe width="560" height="315" :src="embedLink( job.embed )" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>

                <div class="job-description-details" v-if="job.osdesc">
                    <h3>Job Description</h3>
                    <div v-html="decode( job.desc )"></div>    
                </div>

                <div class="job-description-osdetails" v-if="job.osdesc">
                    <h3>What makes this an open source job?</h3>
                    <div v-html="decode( job.desc )"></div>    
                </div>
            </div>
            
            <div class="job-footer">
                <Btn :to="job.apply" blank>Apply for this Job!</Btn>
            </div>
        </div>
    </div>
</template>

<script>
    import Btn from '@/components/Btn.vue'
    import he from 'he'

    export default {
        name: 'JobInlineSingle',
        components : {
            Btn
        },
        methods : {
            decode :  str => he.decode( str ),
            closeOverlay () {
                const q = this.$route.query
                const query = {
                        tags   : q.tags,
                        types  : q.types,
                        state  : q.state,
                        search : q.search,
                        remote : q.remote,
                        id: this.uid
                    } 
                this.$router.push({ query })
            },
            embedLink( id ){
                return "https://www.youtube.com/embed/" + id
            }
        },
        props : [ 'job' ]
    }
</script>

<style lang="scss" scoped>
    @import "../scss/vars";
    @import "../scss/wrapper";
    @import "../scss/pill";

    .single-job-inline-container{
        // margin: 0.5rem 1.25rem;
        margin: 0.5rem;
        border-radius: $radius;
        padding: 1rem;
        background: white;
        flex-basis: 50%;
        flex-shrink: 0;
        z-index: 100;
        position: relative;
        @media screen and (min-width: $b1){
            padding: 2rem 4rem;
        }
    }

    .job{
        &-brand{
            display: flex;
            align-items: center;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid rgba( 0, 0, 0, 0.1);
        }

        &-title{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        &-logo{
            max-width: 8rem;
            @media screen and (min-width: $b1){
                max-width: 12rem;
            }
            // height: 6rem;
            // background: $pale-gray;
            margin-right: 2rem;
        }

        &-footer{
            border-top: 1px solid rgba( 0, 0, 0, 0.1);
            padding-top: 2rem;
            display: flex;
            justify-content: flex-end;
        }

        &-video{
            margin-bottom: 3rem;
            background-color: #eee;
            border-radius: $radius;

            padding: 1rem;

            @media screen and (min-width: $b2){
                padding: 2rem 10%;
            }
        }

        &-description{
            margin-top: 2rem;
            margin-bottom: 2rem;
            h1 {
                line-height: 1;
                order: 1;
            }
            h2{
                font-size: 1.6rem;
                color: $mid-gray;
                // margin-bottom: 1rem;
            }
            h4 {
                font-size: 1.8rem;
                color: $gray;
                font-weight: 700;
                // margin-bottom: 1rem;
            }

            &-meta{
                display: flex;
                margin-bottom: 3rem;

                div{
                    background-color: #eee;
                    margin-right: 1rem;
                    border-radius: $radius;
                    padding: 0.25rem 1rem;
                    font-size: 1.4rem;
                }
            }

            &-other{
                width: 35%;
                float: right;
                margin-left: 2rem;
                margin-bottom: 2rem;
                padding-left: 2rem;
                text-align: right;
                display: none;
                @media screen and (min-width: $b1){
                    display: inline;
                }
            }

            &-details{
                margin-bottom: 3rem;
            }

            &-osdetails{
                padding: 2rem;
                background-color: #eee;
                margin-bottom: 2rem;
                border-radius: $radius;
            }
        }
    }

    .responsive-container{
        position: relative;
        padding-bottom: 56.25%;
        height: 0;

        iframe{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }

    .close{
        display: block;
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
        cursor: pointer;
        margin-left: auto;
        background-image: url( "../assets/close.svg" );
        background-color: white;
        background-position: right center;
        background-repeat: no-repeat;
        background-size: 40%;
    }

</style>